<template><div><h1 id="ab-buchungsprotokoll-drucken" tabindex="-1"><a class="header-anchor" href="#ab-buchungsprotokoll-drucken"><span>AB-Buchungsprotokoll drucken</span></a></h1>
<p>AB-Buchungsprotokoll — Protokoll Aggregierte Buchungen generieren</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Protokoll werden die aggregierten Buchungen eines Laufs wahlweise pro Tag und/oder der Periode zusammengefasst. Die Tageszusammenfassung entspricht weitgehend der Ansicht der aggregierten Buchungen in funtrade. In der „Periodenzusammenfassung wird z.B. bei einer monatlichen Periode das Monatstotal ausgegeben.</p>
<p>Pfad: <code v-pre>Buchhaltung → Verarbeitungsläufe → Aggregierte Buchungen generieren</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Journalnummer</dt>
<dd>Angabe der zu druckenden Journalnummer</dd>
<dt>Druck</dt>
<dd>Druck des Protokolls in 2 Varianten (siehe unten)</dd>
</dl>
<h2 id="output" tabindex="-1"><a class="header-anchor" href="#output"><span>Output</span></a></h2>
<p>Die Ausgabe erfolgt in 3 Varianten.</p>
<ol>
<li>
<p>Zusammenfassung pro Periode:</p>
</li>
<li>
<p>Zusammenfassung pro Tag</p>
</li>
<li>
<p>Zusammenfassung pro Tag und Periode:</p>
<p>Zeigt die Varianten „Zusammenfassung pro Tag“ und „Zusammenfassung pro Periode“ in einem Dokument an.</p>
</li>
</ol>
</div></template>


